import { HandleSendUnsafeReceiveHelperBase } from './HandleSendUnsafeReceiveHelperBase';
export class HandleSendUnsafeHelper extends HandleSendUnsafeReceiveHelperBase {
    constructor() {
        super(...arguments);
        this.lessThan = true;
    }
}

//# sourceMappingURL=HandleSendUnsafeHelper.js.map
